import { Action } from "redux";
import { LocationChangeAction, LOCATION_CHANGE } from "react-router-redux";

export function isLocationChangeAction(a?: Action): a is LocationChangeAction {
    return !!a && a.type === LOCATION_CHANGE;
}
